import { useNavigate, useParams } from "react-router-dom";
import "./AppEmployeeRecords.css";
import { useEffect, useState } from "react";
import { Button, Icon } from "../../../ds2/components";
import { AppEmployeeRecordNew } from "./AppEmployeeRecordNew";
import { EmployeeRecord, EmployeeReferenceType } from "winslow-core";
import { apiGetEmployeeRecordsForWorkspace } from "../../../services/EmployeeRecordService";
import { useDispatch, useSelector } from "react-redux";
import { selectUIStates, selectUser, setUIStates } from "../../../redux/features/appData";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import { erGetCPValue } from "./employeeRecordUtils"
import { UserPlus, Eye, Edit, Trash2, User, Expand, Users, Briefcase, Building } from "lucide-react";
import { ActionLink } from "../../../ds2/components/ActionLink";
import { openEmployeeProfileSidebar } from "../../../redux/features/agent/agentSlice";

const TABS = {
    EMPLOYEES: "employees",
    CONTRACTORS: "contractors",
    VENDORS: "vendors",
}

type AppEmployeeRecordsProps = {

}   

export const AppEmployeeRecords = ({} : AppEmployeeRecordsProps) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const storeUser = useSelector(selectUser)
    const uiStates = useSelector(selectUIStates);
    
    const { employeeId } = useParams();   // id or "new"
    const [employeeRecords, setEmployeeRecords] = useState<EmployeeRecord[] | undefined>(undefined);
    const [tab, setTab] = useState<string>(TABS.EMPLOYEES);

    useEffect(() => {
        if (storeUser?.currentWorkspaceId && (employeeId === "refresh" || !employeeId || !employeeRecords)) {
            (async () => {
                const ers = await apiGetEmployeeRecordsForWorkspace(storeUser.currentWorkspaceId || "");

                if (!ers) {
                    console.error("Failed to get employee records for workspace");
                    toast("Failed to get employee records for workspace", toastFail);
                    return;
                }

                setEmployeeRecords(ers);

                if (employeeId === "new") {
                    dispatch(setUIStates({...uiStates, hrisLocation: "Add Employee"}));
                } else if (employeeId && employeeId !== "refresh") {
                    dispatch(setUIStates({...uiStates, hrisLocation: "View Employee"}));
                } else {
                    dispatch(setUIStates({...uiStates, hrisLocation: "Manage Employees"}));
                }
            })();
        } 
    }, [employeeId]);

    // useEffect(() => {
    //     console.log("[AppEmployeeRecords] id: ", employeeId);
    // }, [employeeId]);

    const handleEditEmployeeRecord = (er: EmployeeRecord) => {
        console.log("[AppEmployeeRecords] handleEditEmployeeRecord: ", er);
        navigate(`/app/employee-records/${er.id}`);
    }

    const inactiveEmployeeRecords = employeeRecords?.filter((er: EmployeeRecord) => {
        if (er.active) {
            return false;
        }
        switch(er.employeeType) {
            case "US_FULL_TIME":
            case "US_PART_TIME":
            case "INT_FULL_TIME":
                return tab === TABS.EMPLOYEES;
            case "US_CONTRACTOR":
            case "INT_CONTRACTOR":
                return tab === TABS.CONTRACTORS;
            case "US_VENDOR":
                return tab === TABS.VENDORS;
            default:
                return false;
        }
    });

    const activeEmployeeRecords = employeeRecords?.filter((er: EmployeeRecord) => {
        if (!er.active) {
            return false;
        }
        switch(er.employeeType) {
            case "US_FULL_TIME":
            case "US_PART_TIME":
            case "INT_FULL_TIME":
                return tab === TABS.EMPLOYEES;
            case "US_CONTRACTOR":
            case "INT_CONTRACTOR":
                return tab === TABS.CONTRACTORS;
            case "US_VENDOR":
                return tab === TABS.VENDORS;
            default:
                return false;
        }
    });

    const handleViewEmployeeRecord = (er: EmployeeRecord) => {
        dispatch(openEmployeeProfileSidebar({
            employeeId: er.id,
            type: EmployeeReferenceType.EMPLOYEE_RECORD
        }));
    }

    const handleExpandEmployeeRecord = (er: EmployeeRecord) => { 
        console.log("[AppEmployeeRecords] handleViewEmployeeRecord: ", er);
        navigate(`/app/employee-records/view/${er.id}`);
    } 

    const handleDeleteEmployeeRecord = (er: EmployeeRecord) => {
        console.log("[AppEmployeeRecords] handleDeleteEmployeeRecord: ", er);
        // TODO: Implement delete functionality
    }

    console.log("[AppEmployeeRecords] employeeRecords: ", employeeRecords);

    return (
        <>
            {employeeId && employeeId !== "refresh" &&
                <AppEmployeeRecordNew id={employeeId === "new" ? undefined : employeeId}/>
            }
            {(!employeeId || employeeId === "refresh") && employeeRecords && 
                <div className="app-employee-records">
                    <div className="app-employee-records-tabs">
                        <div 
                            className={tab === TABS.EMPLOYEES ? 
                                "app-employee-records-tab-selected" : "app-employee-records-tab"
                            }
                            onClick={() => setTab(TABS.EMPLOYEES)}
                        >
                            <Users size={16} />
                            <span>Employees</span>
                        </div>
                        <div 
                            className={tab === TABS.CONTRACTORS ? 
                                "app-employee-records-tab-selected" : "app-employee-records-tab"
                            }
                            onClick={() => setTab(TABS.CONTRACTORS)}
                        >
                            <Briefcase size={16} />
                            <span>Contractors</span>
                        </div>
                        <div 
                            className={tab === TABS.VENDORS ? 
                                "app-employee-records-tab-selected" : "app-employee-records-tab"
                            }
                            onClick={() => setTab(TABS.VENDORS)}
                        >
                            <Building size={16} />
                            <span>Vendors</span>
                        </div>
                        <div className="app-employee-records-tab-actions">
                            <ActionLink
                                label="Add Employee"
                                leftIcon={<UserPlus size={16} />}
                                onClick={() => {
                                    navigate("/app/employee-records/new");
                                }}
                            />

                            {/* <div
                                className="app-employee-records-tab-action"
                                onClick={() => {
                                    navigate("/app/employee-records/new");
                                }}
                            >
                                <UserPlus size={16}/> Add Employee
                            </div> */}
                            
                        </div>
                        
                    </div>

                    {activeEmployeeRecords && activeEmployeeRecords.length > 0 &&
                        <>
                            <div className="app-employee-records-section">
                                {tab === TABS.EMPLOYEES && "Active Employees"}
                                {tab === TABS.CONTRACTORS && "Active Contractors"}
                                {tab === TABS.VENDORS && "Active Vendors"}
                                <span>{activeEmployeeRecords?.length} {tab === TABS.EMPLOYEES ? "Employees" : tab === TABS.CONTRACTORS ? "Contractors" : "Vendors"}</span>
                            </div>

                            <div className="app-employee-records-table-container">
                                <table className="app-employee-records-table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Title</th>
                                            <th>Email</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activeEmployeeRecords.map((er: EmployeeRecord) => (
                                            <tr key={er.id} className="app-employee-records-row">
                                                <td className="app-employee-records-name-cell">
                                                    <div 
                                                        className="app-employee-records-name-content app-employee-records-name-clickable"
                                                        onClick={() => handleViewEmployeeRecord(er)}
                                                    >
                                                        <div className="app-employee-records-avatar">
                                                            {er.avatarURL ? (
                                                                <img 
                                                                    src={er.avatarURL} 
                                                                    alt={`${erGetCPValue(er, "system-firstName")} ${erGetCPValue(er, "system-lastName")}`}
                                                                    className="app-employee-records-avatar-img"
                                                                />
                                                            ) : (
                                                                <div className="app-employee-records-avatar-placeholder">
                                                                    {erGetCPValue(er, "system-firstName")?.charAt(0) || ''}{erGetCPValue(er, "system-lastName")?.charAt(0) || ''}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <strong>{erGetCPValue(er, "system-firstName")} {erGetCPValue(er, "system-lastName")}</strong>
                                                    </div>
                                                </td>
                                                <td className="app-employee-records-title-cell">
                                                    {erGetCPValue(er, "system-title") || '-'}
                                                </td>
                                                <td className="app-employee-records-email-cell">
                                                    {er.workEmail}
                                                </td>
                                                <td className="app-employee-records-actions-cell">
                                                    <div className="app-employee-records-actions-group">
                                                        <Icon
                                                            variant="tertiary"
                                                            size="md"
                                                            icon={<Eye size={16} />}
                                                            onClick={() => handleViewEmployeeRecord(er)}
                                                        />
                                                        <Icon
                                                            variant="tertiary"
                                                            size="md"
                                                            icon={<Expand size={16} />}
                                                            onClick={() => handleExpandEmployeeRecord(er)}
                                                        />
                                                        <Icon
                                                            variant="tertiary"
                                                            size="md"
                                                            icon={<Edit size={16} />}
                                                            onClick={() => handleEditEmployeeRecord(er)}
                                                        />
                                                        <Icon
                                                            variant="tertiary"
                                                            size="md"
                                                            icon={<Trash2 size={16} />}
                                                            onClick={() => handleDeleteEmployeeRecord(er)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    }


                    {inactiveEmployeeRecords && inactiveEmployeeRecords.length > 0 &&
                        <>
                            <div className="app-employee-records-section">
                                {tab === TABS.EMPLOYEES && "Inactive Employees"}
                                {tab === TABS.CONTRACTORS && "Inactive Contractors"}
                                {tab === TABS.VENDORS && "Inactive Vendors"}
                                <span>{inactiveEmployeeRecords?.length} {tab === TABS.EMPLOYEES ? "Employees" : tab === TABS.CONTRACTORS ? "Contractors" : "Vendors"}</span>
                            </div>

                            <div className="app-employee-records-table-container">
                                <table className="app-employee-records-table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Title</th>
                                            <th>Email</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {inactiveEmployeeRecords.map((er: EmployeeRecord) => (
                                            <tr key={er.id} className="app-employee-records-row">
                                                <td className="app-employee-records-name-cell">
                                                    <div 
                                                        className="app-employee-records-name-content app-employee-records-name-clickable"
                                                        onClick={() => handleViewEmployeeRecord(er)}
                                                    >
                                                        <div className="app-employee-records-avatar">
                                                            {er.avatarURL ? (
                                                                <img 
                                                                    src={er.avatarURL} 
                                                                    alt={`${erGetCPValue(er, "system-firstName")} ${erGetCPValue(er, "system-lastName")}`}
                                                                    className="app-employee-records-avatar-img"
                                                                />
                                                            ) : (
                                                                <div className="app-employee-records-avatar-placeholder">
                                                                    {erGetCPValue(er, "system-firstName")?.charAt(0) || ''}{erGetCPValue(er, "system-lastName")?.charAt(0) || ''}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <strong>{erGetCPValue(er, "system-firstName")} {erGetCPValue(er, "system-lastName")}</strong>
                                                    </div>
                                                </td>
                                                <td className="app-employee-records-title-cell">
                                                    {erGetCPValue(er, "system-title") || '-'}
                                                </td>
                                                <td className="app-employee-records-email-cell">
                                                    {er.workEmail}
                                                </td>
                                                <td className="app-employee-records-actions-cell">
                                                    <div className="app-employee-records-actions-group">
                                                        <Icon
                                                            variant="tertiary"
                                                            size="md"
                                                            icon={<Eye size={16} />}
                                                            onClick={() => handleViewEmployeeRecord(er)}
                                                        />
                                                        <Icon
                                                            variant="tertiary"
                                                            size="md"
                                                            icon={<Edit size={16} />}
                                                            onClick={() => handleEditEmployeeRecord(er)}
                                                        />
                                                        <Icon
                                                            variant="tertiary"
                                                            size="md"
                                                            icon={<Trash2 size={16} />}
                                                            onClick={() => handleDeleteEmployeeRecord(er)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    }

                    {activeEmployeeRecords && activeEmployeeRecords.length === 0 && inactiveEmployeeRecords && inactiveEmployeeRecords.length === 0 && (
                        <div className="app-employee-records-zero-state">
                            <div className="app-employee-records-zero-state-content">
                                <div className="app-employee-records-zero-state-icon">
                                    <User size={48} />
                                </div>
                                <h3>No {tab === TABS.EMPLOYEES ? "Employees" : tab === TABS.CONTRACTORS ? "Contractors" : "Vendors"} Found</h3>
                                <p>There are no {tab === TABS.EMPLOYEES ? "employees" : tab === TABS.CONTRACTORS ? "contractors" : "vendors"} in your workspace.</p>
                            </div>
                        </div>
                    )}
                </div>
            }
        </>
    )
}